// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { NetworkSource } from "@lib/messaging/NetworkSource";

/**
 * Encapsulates the context information that is associated with an RPC call.
 * Used by the `ILocalRpcHub` to handle RPC calls.
 */
export interface IRpcContext
{
  readonly destination: NetworkSource;
  readonly isNotification: boolean;
  readonly source: NetworkSource;
}